import {IconButton} from '#/components/buttons/icon-button';
import {ReactComponent as IconStatusLoading} from '#/components/icons/ico-status-loading.svg';
import {TrashIcon, XMarkIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useState} from 'react';
import {useTranslation} from 'react-i18next';

type DeleteConfirmButtonCompoundProps = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  onDelete: () => Promise<void>;
};

export const DeleteConfirmButtonCompound: FunctionComponent<DeleteConfirmButtonCompoundProps> = ({
  isOpen,
  toggleIsOpen,
  onDelete,
}) => {
  const {t} = useTranslation('translation');

  const [isDeleting, setIsDeleting] = useState(false);

  const onDeleteClick = async () => {
    setIsDeleting(true);
    await onDelete();
    setIsDeleting(false);
  };

  return (
    <div className='flex gap-2 text-white text-xs relative'>
      {isOpen ? (
        <>
          <button
            className='w-full hover:opacity-70 align-middle py-1 px-2 overflow-hidden rounded bg-downred relative'
            onClick={onDeleteClick}
          >
            <span>{t('actions.confirmDeletion')}</span>
            {isDeleting && (
              <span className='absolute top-0 left-0 w-full h-full bg-downred flex-center'>
                <IconStatusLoading
                  role='status'
                  className='w-4 aspect-square animate-spin text-gray-600 fill-downred'
                />
              </span>
            )}
          </button>
          <IconButton
            IconComponent={XMarkIcon}
            iconClassName='w-4 h-4 stroke-gray-400 group-hover:stroke-white fill-transparent group-hover:fill-white'
            onClick={toggleIsOpen}
          />
        </>
      ) : (
        <IconButton
          IconComponent={TrashIcon}
          iconClassName='w-4 h-4 stroke-gray-400 group-hover:stroke-white fill-transparent group-hover:fill-white'
          onClick={toggleIsOpen}
        />
      )}
    </div>
  );
};
